import axios from "axios";

export default axios.create(
    {
    baseURL: "/api/productdocumentation",
    headers: {
        "Content-type": "application/json",
    },
});